<div class="container">
  @if (!isLoading()) {
    <form [formGroup]="entryFormGroup" (ngSubmit)="onSubmit()">
      <div class="entry-time">
        <label for="entryTime">Entry Date/Time: </label>
        <p-datepicker
          formControlName="entryTime"
          [showTime]="true"
          hourFormat="24"
          appendTo="body"
          [minDate]="minDateTime()"
          [showIcon]="true"
        />
      </div>
      <div class="break"></div>
      <p-editor
        formControlName="entryText"
        [style]="{ height: '24vh' }"
        (onTextChange)="validateForm()"
      />
      <div class="break"></div>
      <div class="bottom-section">
        <p class="notice">
          Your name and the current date/time will automatically be added to
          your comments.
        </p>
        <button
          pButton
          pRipple
          type="submit"
          label="OK"
          class="p-button-raised p-button-success right-align"
          [disabled]="!entryFormGroup.valid"
        ></button>
      </div>
    </form>
  }
  @if (isLoading()) {
    <p-progressSpinner />
  }
</div>
